import { Controller } from '@hotwired/stimulus';

export default class BabyStepMenuController extends Controller {
  static targets = ['babyStepLockup', 'menu'];

  toggleMenu(event) {
    const menuClassList = this.menuTarget.classList;
    const menuExpandedClassName = 'BabyStepMenu-expanded';

    if (menuClassList.contains(menuExpandedClassName)) {
      event.preventDefault();
      this.menuTarget.classList.remove(menuExpandedClassName);
      this.babyStepLockupTarget.classList.remove('is-hidden');
    } else {
      this.menuTarget.classList.add(menuExpandedClassName);
      this.babyStepLockupTarget.classList.add('is-hidden');
    }
  }
}
